import { z } from "zod";
import { galleryFiltersSchema } from "..";

export const POST_allGalleries = {
  params: z.object({}),
  query: z.object({}),
  body: z.object({
    limit: z.coerce.number().optional(),
    page: z.coerce.number().optional(),
    collaboratorOrCreator: z.string().optional(),
    sort: z.enum(["new-to-old", "old-to-new"]).optional(),
    filters: galleryFiltersSchema.optional(),
  }),
};

export const PATCH_GALLERY = z
  .object({
    title: z.string().optional(),
    slug: z.string().optional(),
    description: z.string().optional(),
    creator: z.string().optional(),
    posts: z.string().array().optional(),
    visible: z.enum(["everyone", "followers", "talents", "private"]).optional(),
    talents: z.string().array().optional(),
    followers: z.string().array().optional(),
  })
  .refine(
    (data) => {
      // At least one of the fields must be present
      return (
        !!data.title ||
        !!data.description ||
        !!data.creator ||
        !!data.posts ||
        !!data.visible ||
        !!data.talents ||
        !!data.followers
      );
    },
    {
      message: "Some of the fields you have entered are invalid",
    }
  );
